module.exports = __webpack_public_path__ + "img/customer-a-057.ad08b896.png";